import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LayoutCrudIndexModule } from '../registration/shared/layout-crud-index/layout-crud-index.module';
import { HomeCardsRoutingModule } from './home-cards-routing.module';
import { HomeCardsComponent } from './home-cards.component';
import { ReactiveFormsModule } from '@angular/forms';

// Novos componentes
import { SettingsDialogComponent } from './settings-dialog/settings-dialog.component';
import { CarouselConfigDialogComponent } from './carousel-config-dialog/carousel-config-dialog.component';

@NgModule({
    declarations: [
        HomeCardsComponent,
        SettingsDialogComponent,
        CarouselConfigDialogComponent
    ],
    imports: [
        CommonModule,
        HomeCardsRoutingModule,
        AngularMaterialModule,
        FlexLayoutModule,
        LayoutCrudIndexModule,
        ReactiveFormsModule
    ]
})
export class HomeCardsModule { } 